import { animate, utils, createDraggable, spring, onScroll } from 'animejs';

export function animeLeftRightSlide() {
    const container     = document.querySelector('.anime--gallery-container')
    const track         = document.querySelector('.anime--gallery-track')

    if (container && track) {
        const slides        = Array.from(track.querySelectorAll('.anime--slide-item'))
        
        let currentIndex    = 0;
        const totalSlides   = slides.length;

        const updateSlideClasses = () => {
            slides.forEach((slide, index) => {
                if (index === currentIndex) {
                    slide.classList.remove('anime--slide-hidden');
                    slide.classList.add('anime--slide-active');
                } else {
                    slide.classList.add('anime--slide-hidden');
                    slide.classList.remove('anime--slide-active');
                }
            });
        };

        // Configuration for animations
        const configTrack = {
            easing: 'easeInOutQuad', 
            duration: 500,
        };

        const configInnerAnim = (offsetX) => ({
            translateX: offsetX + '%', // Slide out slightly from side (12% or -12%)
            opacity: `1`,
            duration: 650,
            easing: 'easeOutCubic'
        });

        const updateGallery = () => {
            const slideWidth = container.clientWidth; 

            animate('.anime--gallery-track', {
                ...configTrack,
                translateX: `-${currentIndex * 100}%`,
                
                complete() {
                    // Step 2 (Callback): Once track is fully in place, animate inner content
                    setTimeout(() => { 
                        playInnerAnimation(slides[currentIndex])
                    }, 300);
                }
            });

        };

        const resetSlides = () => {
            const activeSlideElement = slides[currentIndex]
            const leftItem = activeSlideElement.querySelector('.anime--content-left');
            const rightItem = activeSlideElement.querySelector('.anime--content-right');

            animate(leftItem, {
                duration: 650,
                easing: 'easeInOutQuad',
                opacity: [1, 0]
            })
            
            animate(rightItem, {
                duration: 650,
                easing: 'easeInOutQuad',
                opacity: [1, 0]
            })
        }


        const playInnerAnimation = (activeSlideElement) => {
            const leftItem = activeSlideElement.querySelector('.anime--content-left');
            const rightItem = activeSlideElement.querySelector('.anime--content-right');

            if (leftItem && rightItem) {
                
                // Reset previous animation state (optional, but ensures effect plays every time)
                // Not here... Setting it right before the animation is weird
                // anime.set([leftItem, rightItem], { opacity: 0.1 }); 

                animate(leftItem, {
                    duration: 650,
                    easing: 'easeInOutQuad',
                    opacity: [0.1, 1],
                    translateX: ['-100%', '0%']     
                })
                
                animate(rightItem, {
                    duration: 650,
                    easing: 'easeInOutQuad',
                    opacity: [0.1, 1],
                    translateX: ['100%', '0%']     
                })
            }
        };

        const nextSlide = () => {
            console.log('next')
            resetSlides()

            if (currentIndex < totalSlides - 1) {
                currentIndex++;
            } else {
                // Optional: Loop back
                currentIndex = 0;        
            }

            updateSlideClasses()
            updateGallery()
        };

        const prevSlide = () => {
            console.log('prev')
            resetSlides()

            if (currentIndex > 0) {
                currentIndex--;
            } else {
                // Optional: Loop end
                currentIndex = totalSlides -1; 
            }

            updateSlideClasses()
            updateGallery()
        };
        
        document.querySelector('.anime--nextBtn').addEventListener('click', nextSlide);   
        document.querySelector('.anime--prevBtn').addEventListener('click', prevSlide);

        // Initial load animation (to ensure first slide reveals properly)
        setTimeout(() => { 
            updateSlideClasses()
            playInnerAnimation(slides[0])
        }, 100); 
    }
}
